import React from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules } from '@utils';

import { globalActions, useAppDispatch } from '@modules';

import Button from '@components/Button';
import LoginLayout from '@layouts/LoginLayout';

import style from './Intro.scss';

const cn = bemCssModules(style, 'Intro');

export const Intro: CustomFC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const handleClick = () => {
    dispatch(globalActions.setProtect('setup2fa'));
  };
  return (
    <LoginLayout isHideLinks backButton={false}>
      <h1 className={cn('title')}>{t('otp.intro.header')}</h1>
      <div className={cn('description')}>{t('otp.intro.description1')}</div>
      <div className={cn('description')}>{t('otp.intro.description2')}</div>
      <Button className={cn('button')} onClick={handleClick}>
        {t('otp.intro.continue')}
      </Button>
    </LoginLayout>
  );
};

export default Intro;
